import { useCallback } from "react";

import { Button, Popover } from "@snapchat/snap-design-system";
import { CalendarIcon, CrossIcon } from "@snapchat/snap-design-system-icons";

import { DisplayComponent } from "../../../../common/components";
import { formatMediumDate } from "../../../../common/formatters";
import { stopPropagation } from "../../../../common/utils/event";
import { RangeModifier } from "../../../../connections/models";
import { ScheduleDatePicker } from "../ScheduleDatePicker";
import { ScheduleDatePickerInputContainer, buttonStyle, popoverStyle } from "../ScheduleDateRange.styles";

interface SchedulerCellProps {
    range: RangeModifier;
    onChange: (data: RangeModifier) => void;
    readonly: boolean;
}

export function SchedulerCell({ range, onChange, readonly }: SchedulerCellProps) {
    const isNullDates = !range.from || !range.to;
    const initialMonth = isNullDates ? new Date() : null;
    const handleReset = useCallback(() => {
        onChange(new RangeModifier());
    }, [onChange]);

    return (
        <ScheduleDatePickerInputContainer onClick={stopPropagation}>
            <Popover
                className={popoverStyle}
                content={<ScheduleDatePicker range={range} onChange={onChange} initialMonth={initialMonth as Date} />}
                trigger="click"
            >
                <Button isDisabled={readonly} className={buttonStyle}>
                    <span>
                        {isNullDates
                            ? "Always"
                            : `${formatMediumDate(range.from as Date)} - ${formatMediumDate(range.to as Date)}`}
                    </span>
                    <DisplayComponent show={isNullDates}>
                        <CalendarIcon />
                    </DisplayComponent>
                    <DisplayComponent show={!isNullDates} onClick={handleReset}>
                        <CrossIcon />
                    </DisplayComponent>
                </Button>
            </Popover>
        </ScheduleDatePickerInputContainer>
    );
}
